<template>
    <div style="height: calc(100vh - 10rem)">
        <h1>{{ $t('labels.edit_entry') }}</h1>

        <form method="post" v-if="currentEntry">
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="employee_id" v-text="$t('labels.employee')"></label>
                        <select name="employee_id" id="employee_id" class="form-control disabled" v-model="currentEntry.employee_id" disabled>
                            <option value="" v-text="$t('labels.select_an_employee')"></option>
                            <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                                {{ employee.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group">
                        <label for="activity_id" v-text="$t('fields.activity_id')"></label>
                        <select name="activity_id" id="activity_id" class="form-control" v-model="currentEntry.activity_id">
                            <option value="" v-text="$t('labels.select_an_activity')"></option>
                            <option v-for="activity in activities" :key="activity.id" :value="activity.id">
                                {{ activity.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="team" v-text="$t('labels.team')"></label>
                        <select name="team" id="team" class="form-control" v-model="currentEntry.team_id">
                            <option value="" v-text="$t('labels.select_a_team')"></option>
                            <option v-for="team in teams" :key="team.id" :value="team.id">
                                {{ team.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group">
                        <label for="packaging" v-text="$t('labels.packaging')"></label>
                        <select name="packaging" id="packaging" class="form-control" v-model="currentEntry.packaging">
                            <option value="" v-text="$t('labels.select_a_packaging')"></option>
                            <option v-for="packaging in packagings" :key="packaging.id" :value="packaging.id">
                                {{ packaging.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label for="row" v-text="$t('labels.row')"></label>
                        <select name="row" id="row" class="form-control" v-model="currentEntry.row_id">
                            <option value="" v-text="$t('labels.select_a_row')"></option>
                            <option v-for="row in rows" :key="row.id" :value="row.id">
                                {{ row.title }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group">
                        <label for="row_status" v-text="$t('labels.row_status')"></label>
                        <select name="row_status" id="row_status" class="form-control" v-model="currentEntry.row_status">
                            <option value="" v-text="$t('labels.select_a_row_status')"></option>
                            <option value="finished" v-text="$t('statuses.row.finished')"></option>
                            <option value="not_finished" v-text="$t('statuses.row.not_finished')"></option>
                            <option value="finished_pending" v-text="$t('statuses.row.finished_pending')"></option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label for="amount" v-text="$t('labels.amount')"></label>
                <input type="text" name="amount" id="amount" class="form-control" v-model="currentEntry.amount">
            </div>

            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label v-text="$t('labels.start')"></label>
                        <datetime v-model="currentEntry.start" type="datetime" input-id="start" input-class="form-control" hidden-name="start" :phrases="{ok: 'OK', cancel: $t('labels.cancel')}" :format="getFormat()" auto></datetime>
                    </div>
                </div>

                <div class="col-6">
                    <div class="form-group">
                        <label v-text="$t('labels.end')"></label>
                        <datetime v-model="currentEntry.end" type="datetime" input-id="end" input-class="form-control" hidden-name="end" :phrases="{ok: 'OK', cancel: $t('labels.cancel')}" :format='getFormat()' auto></datetime>
                    </div>
                </div>
            </div>
        </form>

        <div class="app-actions">
            <div class="col-sm-6">
                <button class="btn btn-danger btn--xl" @click="close">{{ $t('labels.cancel') }}</button>
            </div>

            <div class="col-sm-6 text-right">
                <button class="btn btn-success btn--xl" @click="updateEntry()">{{ $t('labels.save') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import {DateTime} from 'luxon';
import {Datetime} from 'vue-datetime';

export default {
  name: 'edit-entry',

  data() {
    return {
      currentEntry: null
    }
  },

  components: {Datetime},

  computed: {
    employees() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$store.state.employees.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      })
    },

    activities() {
      return this.$store.getters.activities
    },

    teams() {
      if (!this.$store.state.teams) return [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$store.state.teams.sort((a, b) => {
        if (a.name.toString().toLowerCase() < b.name.toString().toLowerCase()) return -1;
        if (a.name.toString().toLowerCase() > b.name.toString().toLowerCase()) return 1;
        return 0;
      })
    },

    packagings() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$store.state.packagings.sort((a, b) => {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      })
    },

    rows() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.$store.state.rows.sort((a, b) => {
        if (a.title.toString().toLowerCase() < b.title.toString().toLowerCase()) return -1;
        if (a.title.toString().toLowerCase() > b.title.toString().toLowerCase()) return 1;
        return 0;
      })
    }
  },

  methods: {
    getFormat() {
      return DateTime.DATETIME_SHORT_WITH_SECONDS;
    },

    close() {
      this.$router.go(-1)
    },

    updateEntry() {
      for (let key in this.currentEntry) {
        // eslint-disable-next-line no-prototype-builtins
        if (this.currentEntry.hasOwnProperty(key) && this.currentEntry[key] === '' || this.currentEntry[key] === null) {
          this.currentEntry[key] = null;

          if (key === 'team_id') this.currentEntry.team_name = null;
          else if (key === 'row_id') this.currentEntry.row = null;
        }
      }

      this.$store.dispatch('updateTimesheetEntry', this.currentEntry).then(() => {
        this.$store.commit('setChecked', -1)
      });
    }
  },

  mounted() {
    this.currentEntry = {...this.$store.state.timesheetEntries.find(entry => entry.id === this.$route.params.id)};

    for (let key in this.currentEntry) {
      if (this.currentEntry[key] === null) this.currentEntry[key] = '';
    }

    window.events.$emit('disableNumpad');

    if (this.$store.getters.currentEmployee === null || this.$store.getters.currentEmployee === undefined) {
      this.$router.push({name: 'pin'});
    }

    let main = document.querySelector('.app-main');
    let sidebar = document.querySelector('.app-sidebar');

    main.classList.add('app-main--fullscreen');
    sidebar.style.display = 'none';

    window.events.$emit('setFullscreen', true);
  },

  beforeDestroy() {
    window.events.$emit('setFullscreen', false);

    let main = document.querySelector('.app-main');
    let sidebar = document.querySelector('.app-sidebar');

    main.classList.remove('app-main--fullscreen');
    sidebar.style.display = 'flex';
  }
}
</script>

<style>
    .form-control:disabled, .form-control[read-only] {
        background: #e9ecef !important;
    }
</style>
